import Text from '@passkeys/ui/text';

import ChainBadge from '@/ui/components/chain-badge';
import Image from '@/ui/components/image';
import { cn } from '@/ui/utils/classnames';

interface CollectibleProps {
  image: string;
  name: string;
  collectionName: string;
  chain: string;
  size?: 'small' | 'medium';
}

function Collectible({
  image,
  name,
  collectionName,
  chain,
  size = 'medium',
}: CollectibleProps) {
  return (
    <div className="flex flex-col">
      <Image
        src={image}
        className={cn(size === 'medium' ? 'rounded-2xl' : 'rounded-[14px]')}
      />

      <div
        className={cn(
          'flex flex-col gap-y-1',
          size === 'medium' ? 'mt-4 px-4' : 'mt-2 px-1',
        )}
      >
        <div className="flex items-center justify-between gap-x-2">
          <Text
            className={cn(
              'truncate',
              size === 'medium' ? 'leading-[28px]' : 'leading-[20px]',
            )}
            size={size === 'medium' ? 24 : 16}
            dataTestId="collectible-name"
          >
            {name}
          </Text>
          <ChainBadge name={chain} size={size} iconOnly={size === 'small'} />
        </div>

        <Text
          monospace
          className="truncate text-black/50 theme-dark:text-white/50"
          size={size === 'medium' ? 14 : 12}
          dataTestId="collectible-collection-name"
        >
          {collectionName}
        </Text>
      </div>
    </div>
  );
}

export default Collectible;
